/**
 * Checks if the expiration date is valid.
 * @function
 * @name isExpirationDateValid
 * @kind function
 * @param {Date | string | null} expirationDate The expiration date.
 * @returns {boolean} Is valid or not valid.
 * @exports
 */
export function isExpirationDateValid(
  expirationDate: Date | string | null
): boolean {
  if (expirationDate === null) return false;
  return new Date(expirationDate)?.getTime() - new Date().getTime() > 0;
}
